export default class Validations {
  static numberValidation(event) {
    if (!/[0-9]/.test(event.key)) {
       event.preventDefault();
    }
  }
  static maxValue(event, val) {
    if (event.target.value > val) {
       event.preventDefault();
    }
  }
  static isValidEmail(email) {
    // Prevent ReDoS: validate input type and limit length before regex
    if (!email || typeof email !== 'string') {
      return false;
    }
    
    // RFC 5321 maximum email length is 254 characters (local + @ + domain)
    // Early return prevents processing extremely long strings
    if (email.length > 254) {
      return false;
    }
    
    // ReDoS-safe regex: uses greedy quantifiers with explicit boundaries to prevent backtracking
    // Pattern breakdown:
    // - ^[^\s@]+ : Greedy match of one or more non-whitespace, non-@ characters (local part)
    // - @ : Literal @ symbol (clear boundary, prevents backtracking)
    // - [^\s@]+ : Greedy match of one or more non-whitespace, non-@ characters (domain name)
    // - \. : Literal dot (clear boundary, prevents backtracking)
    // - [^\s@]+$ : Greedy match of one or more non-whitespace, non-@ characters (TLD)
    // ReDoS protection:
    // 1. Greedy quantifiers (*, +) match maximally first, then check lookahead - linear time
    // 2. Literal characters (@, .) provide clear boundaries preventing exponential backtracking
    // 3. Character class [^\s@] is atomic - no ambiguity in matching
    // 4. Anchors (^ and $) ensure full string matching
    // 5. Length check (254 chars) limits worst-case input size
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    
    // Additional safeguard: split validation to avoid any potential backtracking
    // This approach validates each part separately, ensuring linear time complexity
    const parts = email.split('@');
    if (parts.length !== 2) {
      return false;
    }
    
    const [localPart, domain] = parts;
    if (!localPart || !domain || localPart.length === 0 || domain.length === 0) {
      return false;
    }
    
    // Validate local part (no whitespace or @)
    if (!/^[^\s@]+$/.test(localPart)) {
      return false;
    }
    
    // Validate domain (must contain at least one dot and valid TLD)
    const domainParts = domain.split('.');
    if (domainParts.length < 2) {
      return false;
    }
    
    // Validate each domain part
    for (const part of domainParts) {
      if (!part || part.length === 0 || !/^[^\s@]+$/.test(part)) {
        return false;
      }
    }
    
    // Final regex check for overall format (now safe due to pre-validation)
    return emailRegex.test(email);
  }
}
